// Hero images served from /public for stable URLs so they can be preloaded
// from index.html (LCP discoverable in initial document).
const hero800 = "/hero-saffron-800.webp";
const hero1200 = "/hero-saffron-1200.webp";
const hero1600 = "/hero-saffron-1600.webp";
import logo from "@/assets/logo-white-r.webp";
import { useAuth } from "@/hooks/useAuth";

export const HeroSection = () => {
  const { user } = useAuth();
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={hero800}
          srcSet={`${hero800} 800w, ${hero1200} 1200w, ${hero1600} 1600w`}
          sizes="100vw"
          alt="Premium Kashmiri saffron and spices"
          width={1200}
          height={675}
          className="w-full h-full object-cover"
          fetchPriority="high"
          loading="eager"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground/80 via-foreground/50 to-transparent" />
      </div>
      <div className="container relative z-10 py-20 md:py-32 lg:py-40">
        <div className="max-w-xl space-y-6 animate-fade-in">
          <img src={logo} alt="Param Kesar®" className="h-24 md:h-32 w-auto drop-shadow-lg" width={400} height={128} fetchPriority="high" decoding="async" />
          <p className="text-gold font-medium tracking-[0.2em] uppercase text-sm">
            From the fields of Kashmir
          </p>
          <h1 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-primary-foreground leading-tight">
            The Purest Kashmiri Saffron, <br />
            <span className="italic text-gold">Handpicked for You</span>
          </h1>
          <p className="text-primary-foreground/80 text-lg max-w-md leading-relaxed">
            Discover our premium Kashmiri saffron, traditional Kahwa teas, and aromatic spice blends — crafted with centuries of heritage.
          </p>
          <div className="flex flex-wrap items-center gap-3 pt-2">
            <a
              href="#products"
              className="inline-flex items-center px-8 py-3 bg-primary text-primary-foreground font-medium rounded-sm hover:bg-primary/90 transition-colors tracking-wide"
            >
              Shop Collection
            </a>
            {!user && (
              <a
                href="/auth?mode=signup"
                className="inline-flex items-center px-8 py-3 border border-primary-foreground/40 text-primary-foreground font-medium rounded-sm hover:bg-primary-foreground/10 transition-colors tracking-wide backdrop-blur-sm"
              >
                Create Account
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
